const initSlider = async () => {
  if (document.querySelector('.block-home_slider') && document.querySelectorAll('.block-home_slider .swiper-slide').length > 1) {
    const { default: Swiper, Autoplay, Pagination, Navigation } = await import('swiper');

    Swiper.use([Autoplay, Pagination, Navigation]);

    new Swiper('.block-home_slider .swiper-container', {
      init: false,
      speed: 400,
      navigation: {
        nextEl: '.block-home_slider .swiper-button-next',
        prevEl: '.block-home_slider .swiper-button-prev',
      },
      pagination: {
        el: '.block-home_slider .swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      centeredSlides: true,
      autoplay: {
        delay: 4000
      },
      loop: true,
      slidesPerView: 'auto',
      loopedSlides: 5
    }).init();
  }
}

initSlider();
